<template>
	<div class="home">
		<div class="banner_wrap">
			<div class="banner">
				<div class="register_box">
					<div class="title">
						<p>填写基本信息</p>
						<div class="white"></div>
					</div>
					<div class="list">
						<div class="item">
							<img src="../assets/img/icon_money.png" />
							<input type="text" maxlength="10" @input="filterInput" placeholder="请输入您的贷款金额" v-model="money" />
							<span>万元</span>
						</div>
						<div class="item">
							<img src="../assets/img/name.png" />
							<input type="text" maxlength="20" placeholder="请输入您的姓名" v-model="name" />
						</div>
						<div class="item">
							<img src="../assets/img/car.png" />
							<input type="text" maxlength="30" placeholder="请输入您的车辆信息" v-model="carInfo"/>
						</div>
						<div class="item">
							<img src="../assets/img/address.png" />
							<input type="text" placeholder="请输入您的地址" v-model="address" />
						</div>
						<div class="item">
							<img src="../assets/img/phone1.png" class="iphone-icon" />
							<input type="text" maxlength="11" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" placeholder="请输入您的11位手机号码" v-model="mobile"/>
						</div>
						<div class="item">
							<img src="../assets/img/phone1.png" class="iphone-icon" />
							<input type="text" maxlength="11" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" placeholder="请输入介绍人手机号" v-model="referrPhone"/>
						</div>
						<div class="item item_code">
							<div class="get_btn" @click="show()">立即申请</div>
						</div>
					</div>
				</div>
			</div>
	    </div>
	    <div class="img_wrap">
	    	<img src="../assets/img/serce.png"/>
	    </div>
	    <div class="compony">
	    	<p>中旭御龙（深圳）租赁有限公司</p>
			<p class="copy"><a href="http://beian.miit.gov.cn/" target="_blank">苏ICP备2023015410号</a></p>
	    </div>
	    <div class="pop" v-if="flag">
	    	<p>已收到您的申请信息，稍后会安排客服经理与您对接，请稍作等待！</p>
	    	<div class="sure_btn">
	    		<span @click="Cancel()">确定</span>
	    	</div>
	    	<i class="icon_clear" @click="Cancel()"></i>
	    </div>
	</div>
</template>

<script>
	import sIdentify from './identify'
	import $http from '../api'
	export default {
		components: {
			"s-identify": sIdentify
		},	
		data(){
			return{
				money:'',
				name:'',
				carInfo:'',
				address:'',
				mobile:'',
				referrPhone:"",
				code:'',
				flag:false,
				identifyCode: "",
				code_height:35,
				code_width:100
			}
		},
		methods:{
			filterInput(event) {
				// 使用正则表达式只允许数字和小数点
				event.target.value = event.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
			},
			show(){
				if(this.money &&　this.name &&　this.carInfo && this.address){
					let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
					if(!reg.test(this.mobile) || (this.referrPhone && !reg.test(this.referrPhone))){
						alert('请填写正确的手机号！')
					}else{
						$http.post('/customer/save',{
							loanMoney:this.money,
							customerName:this.name,
							carInfo:this.carInfo,
							address:this.address,
							phone:this.mobile,
							referrPhone:this.referrPhone
						}).then(res=>{
							if(res.code===0){
								this.flag=true;
							}else{
								alert(res.msg)
							}
						}).catch(err=>{})
						
						// if(this.code.toLocaleLowerCase() !== this.identifyCode.toLocaleLowerCase()) {
						// 	this.refreshCode();
						// 	this.code='';
						// 	alert('图形验证码错误');
						// }else{
						// 	this.flag=true;
						// }
					}
				}else{
					alert('请填写完整信息！')
				}
			},
			Cancel(){
				this.money='';
				this.name='';
				this.carInfo='';
				this.address='';
				this.mobile='';
				this.code='';
				this.flag=false;
				this.referrPhone = '';
			},
		},
		mounted(){
		}
	}
</script>
<style lang="scss">
	#s-canvas{
		border-radius: 50px;
	}
	input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
	.home {
		background: #fff;
		width: 100%;
		padding-bottom:40px;
		.pop{
			display: block;
			width:350px;
			height:95px;
			padding:50px 50px 30px;
			position:fixed;
			left:0;
			right:0;
			top:0;
			bottom:0;
			margin:auto;
			z-index:8;
			background:#fff;
			box-shadow: 0px 0px 30px #B0ABAB;
			p{
				line-height:30px;
			}
			i.icon_clear{
				display: block;
				width:25px;
				height:25px;
				background:url(../assets/img/clear.png) no-repeat;
				background-size:100%;
				position:absolute;
				right:8px;
				top:8px;
				z-index:9;
				cursor: pointer;
			}
			.sure_btn{
				height:35px;
				text-align: right;
				span{
					display: inline-block;
					width:100px;
					height:35px;
					line-height:35px;
					text-align: center;
					background:#1262B2;
					color:#fff;
					font-size:16px;
					cursor: pointer;
				}
			}
		}
		.compony{
			line-height:45px;
			text-align: center;
			font-size:22px;
			color:#000000;
			opacity: 0.3;
			.copy{
				height:30px;
				line-height:30px;
				a{
					color:#000000;
					font-size:16px;
				}
			}
		}
		.img_wrap{
			padding:65px 0;
			background:#fff;
			img{
				display: block;
				width:1200px;
				margin:0 auto;
			}
		}
		.banner_wrap{
			width: 100%;
			height: 568px;
			background: url(../assets/img/home.png) no-repeat;
			background-size: 100% 100%;
			.banner {
				width: 1200px;
				margin: 0 auto;
				overflow: hidden;				
				.register_box {
					width: 330px;
					height:480px;
					background: #fff;
					border-radius: 12px;
					float: right;
					margin: 50px 0;
					padding: 0 35px;
					.title {
						padding: 25px 0;
						p {
							line-height: 35px;
							text-align: center;
							color: #000000;
							font-size: 28px;
						}
						.white {
							width: 104px;
							height: 4px;
							margin: 8px auto 0;
							background: #d9bd67;
						}
					}
					.list {
						.item {
							width: 334px;
							height: 35px;
							border: 1px solid #d9bd67;
							border-radius: 18px;
							margin-bottom: 16px;
							padding: 5px 55px 6px 53px;
							position: relative;
							box-sizing: border-box;
							img {
								display: block;
								width: 23px;
								height: 25px;
								position: absolute;
								left: 23px;
								top: 5px;
								z-index: 10;
								&.iphone-icon{
									width:16px;
									height:26px;
									top:4px;
									left:25px;
								}
							}
							input {
								display: block;
								width: 100%;
								height: 24px;
								line-height: 24px;
								border: none;
								border-left: 1px solid #B6B6B6;
								padding-left: 10px;
								font-size:13px;
							}
							span {
								display: block;
								height: 35px;
								line-height: 35px;
								position: absolute;
								right: 12px;
								top: 0;
								z-index: 10;
								font-size: 14px;
								color: #757575;
							}
							.get_btn {
								width: 100%;
								height: 41px;
								text-align: center;
								line-height: 40px;
								background-image: linear-gradient(0deg, #b6942b 0%, #d9bd67 100%);
								border-radius: 20px;
								font-size: 20px;
								color: #fff;
								cursor: pointer;
							}
						}
						.item_code {
							width: 100%;
							height: 35px;
							padding: 0;
							border: none;
							border-radius: 0;
							.left {
								margin-right: 110px;
								border: 1px solid rgba(242, 89, 47, 1);
								border-radius: 18px;
								padding: 5px 30px 6px 53px;
								position: relative;
								box-sizing: border-box;
							}
							.code_btn {
								float: right;
								width: 100px;
								height: 35px;
								border-radius: 50px;
								font-size: 12px;
								color: #fff;
								text-align: center;
								line-height: 35px;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
</style>